var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  Camera status changed from\n  "+_vm._s(_vm.getOldStatus)+"\n  to\n  "+_vm._s(_vm.getNewStatus)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }